import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(app)/drop-nft/page.tsx");
